<template>
    <el-dialog :title="$t('public.Detail')" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false"
        @close="handleDialogClose">
        <div class="detail-content" v-loading="loading">
            <!-- 车辆基本信息 -->
            <el-divider content-position="left">{{ $t('maintenanceReminder.basicInfo') }}</el-divider>
            <el-row :gutter="20" class="info-row">
                <el-col :span="8">
                    <div class="info-item">
                        <span class="info-label">{{ $t('maintenanceReminder.vehicleNo') }}:</span>
                        <span class="info-value">{{ record.CarNo }}</span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="info-item">
                        <span class="info-label">{{ $t('maintenanceReminder.vehicleModel') }}:</span>
                        <span class="info-value">{{ record.VehicleModel }}</span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="info-item">
                        <span class="info-label">{{ $t('maintenanceReminder.reminderTime') }}:</span>
                        <span class="info-value">{{ formatTime(record.UpdateTime) }}</span>
                    </div>
                </el-col>
            </el-row>

            <!-- 保养周期信息 -->
            <el-divider content-position="left">{{ $t('maintenanceReminder.maintenanceCycleInfo') }}</el-divider>
            <el-row :gutter="20" class="info-row">
                <el-col :span="8">
                    <div class="info-item">
                        <span class="info-label">{{ $t('maintenanceReminder.maintenanceCycle') }}:</span>
                        <span class="info-value">{{ record.Marker }} km</span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="info-item">
                        <span class="info-label">{{ $t('maintenanceReminder.currentMileage') }}:</span>
                        <span class="info-value">{{ record.EMileage }} km</span>
                    </div>
                </el-col>
            </el-row>
            <!-- 保养零部件详细说明 -->
            <el-divider content-position="left">{{ $t('maintenanceReminder.maintenanceParts') }}</el-divider>
            <div class="parts-container" v-if="maintenanceDetails.length > 0">
                <div v-for="(detail, index) in maintenanceDetails" :key="index" class="part-card">
                    <div class="part-header">
                        <div class="part-title">
                            <span class="part-name">{{ detail.partName }}</span>
                        </div>
                    </div>
                    <div class="maintenance-tasks">
                        <ul class="tasks-list">
                            <li v-for="(task, taskIndex) in detail.maintenanceTasks" :key="taskIndex" class="task-item">
                                <span class="task-num">{{ taskIndex + 1 }}</span>
                                <span class="task-content">{{ task }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <el-empty v-else :description="$t('maintenanceReminder.noMaintenanceData')"></el-empty>
        </div>

        <span slot="footer" class="dialog-footer">

            <el-button @click="closeDialog">
                {{ $t('public.close') }}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import { formatTime } from "@/utils/longyi";

export default {
    name: 'MaintenanceDetailDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        record: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            loading: false,
            maintenanceDetails: []
        };
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit('update:visible', val);
            }
        }
    },
    watch: {
        visible(val) {
            if (val && this.record && this.record.VehicleID) {
                this.loadDetailData();
            }
        },
        record: {
            handler(val) {
                if (val && val.VehicleID) {
                    this.loadDetailData();
                }
            },
            immediate: true
        }
    },
    methods: {
        formatTime(time) {
            return formatTime(time);
        },

        // 加载详情数据
        loadDetailData() {
            if (!this.record || !this.record.VehicleID) {
                return;
            }

            this.loading = true;
            this.$api.MaintananceReminderDetails({
                Vehicles: this.record.VehicleID.toString(),
                VehicleModel: this.record.VehicleModel,
                Language: this.$store.getters.LanguageId,
                Marker: this.record.Marker
            }).then(res => {
                this.loading = false;
                if (res && res.code == 200) {
                    this.maintenanceDetails = this.processMaintenanceDetails(res.data || []);
                }
            }).catch(() => {
                this.loading = false;
            });
        },

        /**
         * 处理接口返回的维保详情数据
         * 接口返回格式：每一行是一个具体的检查项目，需要按照零部件（Part）进行分组
         * 
         * @param {Array} apiData - 接口返回的原始数据
         * @returns {Array} - 处理后的零部件详情数组
         */
        processMaintenanceDetails(apiData) {
            if (!apiData || !Array.isArray(apiData) || apiData.length === 0) {
                return [];
            }

            // 按零部件名称分组
            const partGroups = {};

            apiData.forEach(item => {
                const partName = item.Part || 'Unknown Part';

                if (!partGroups[partName]) {
                    partGroups[partName] = {
                        partName: partName,
                        maintenanceTasks: [],
                        rawItems: []
                    };
                }

                // 添加检查项目到任务列表
                if (item.Items) {
                    partGroups[partName].maintenanceTasks.push(item.Items);
                }

                // 保存原始数据
                partGroups[partName].rawItems.push(item);
            });

            // 转换为数组并补充额外信息
            const result = Object.values(partGroups).map((group, index) => {
                // 删除原始数据，避免传递到前端
                delete group.rawItems;
                return group;
            });

            return result;
        },

        // 关闭弹窗
        closeDialog() {
            this.dialogVisible = false;
        },



        // 弹窗关闭时的处理
        handleDialogClose() {
            this.maintenanceDetails = [];
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
.detail-content {
    max-height: 70vh;
    overflow-y: auto;
    padding: 10px;
}

.info-row {
    margin-bottom: 16px;
}

.info-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
}

.info-label {
    font-weight: 500;
    color: #606266;
    margin-right: 8px;
    min-width: 140px;
}

.info-value {
    color: #303133;
}

.el-divider {
    margin: 24px 0 16px 0;
}

/* 零部件卡片样式 */
.parts-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(48%, 1fr));
    gap: 16px;
    margin-top: 8px;
}

.part-card {
    background: #fafafa;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #ebeef5;
}

.part-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ebeef5;
}

.part-title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.part-name {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.maintenance-tasks {
    background: #fff;
    border-radius: 6px;
    padding: 12px;
}

.tasks-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.task-item {
    display: flex;
    padding: 8px 0;
    border-bottom: 1px dashed #f0f0f0;
    align-items: flex-start;
}

.task-item:last-child {
    border-bottom: none;
}

.task-num {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background: #409eff;
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
    margin-right: 10px;
    flex-shrink: 0;
}

.task-content {
    font-size: 13px;
    color: #606266;
    line-height: 1.5;
}
</style>
